import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { EcommerceNotification } from '../modal';

export default function reducer(state: EcommerceNotification = new EcommerceNotification(),
  action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.ECOMMERCE_NOTIFOCATION_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.ECOMMERCE_NOTIFOCATION_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.ECOMMERCE_NOTIFOCATION_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
